<template>
  <span class="ph-wrap" @mouseenter="onEnter" @mouseleave="onLeave">
    <a :href="'?player=' + encodeURIComponent(name)" class="ph-name" :style="nameStyle" @click.stop>
      <slot>{{ name }}</slot>
    </a>
    <div v-if="visible" class="ph-card" @mouseenter="onCardEnter" @mouseleave="onCardLeave">
      <template v-if="record">
        <div class="ph-line"><b>{{ record.winRate }}%</b> · {{ record.played.toLocaleString() }} games<template v-if="record.tw"> · {{ record.tw.toLocaleString() }} bracket wins</template></div>
        <div v-if="record.champ" class="ph-line ph-champ">👑 {{ record.champ }} title{{ record.champ === 1 ? '' : 's' }} · {{ record.champDef || 0 }} defense{{ (record.champDef || 0) === 1 ? '' : 's' }}<template v-if="record.champReign"> · longest {{ record.champReign }}</template></div>
        <div v-if="topClasses.length" class="ph-line ph-top">{{ topClasses.join(' · ') }}</div>
        <a :href="'?player=' + encodeURIComponent(name)" class="ph-profile" @click.stop>View profile →</a>
      </template>
      <template v-else-if="record === null">
        <div class="ph-line ph-new">New player</div>
        <a :href="'?player=' + encodeURIComponent(name)" class="ph-profile" @click.stop>View profile →</a>
      </template>
      <div v-else class="ph-line ph-loading">Loading…</div>
    </div>
  </span>
</template>

<script>
import { ensurePlayerIndex } from '../lib/playerIndexLoader.js';

export default {
  name: 'PlayerHover',
  props: {
    name: { type: String, required: true },
    nameStyle: { type: [Object, String], default: '' },
  },
  data() {
    return { visible: false, record: undefined, _enterTimer: null, _leaveTimer: null, _onCard: false };
  },
  computed: {
    topClasses() {
      if (!this.record || !this.record.classes) return [];
      return Object.entries(this.record.classes)
        .map(([cls, arr]) => [cls, arr[0]])
        .sort((a, b) => b[1] - a[1])
        .slice(0, 4)
        .map(([cls]) => cls);
    },
  },
  methods: {
    onEnter() {
      clearTimeout(this._leaveTimer);
      this._enterTimer = setTimeout(() => {
        this.visible = true;
        if (this.record === undefined) this.loadRecord();
      }, 150);
    },
    onLeave() {
      clearTimeout(this._enterTimer);
      this._leaveTimer = setTimeout(() => {
        if (!this._onCard) this.visible = false;
      }, 120);
    },
    onCardEnter() {
      this._onCard = true;
      clearTimeout(this._leaveTimer);
    },
    onCardLeave() {
      this._onCard = false;
      this._leaveTimer = setTimeout(() => { this.visible = false; }, 120);
    },
    async loadRecord() {
      const idx = await ensurePlayerIndex();
      if (!idx) { this.record = null; return; }
      const key = Object.keys(idx).find((k) => k.toLowerCase() === this.name.toLowerCase());
      this.record = key ? idx[key] : null;
    },
  },
};
</script>

<style scoped>
.ph-wrap { position: relative; display: inline; }
.ph-name { color: inherit; text-decoration: none; }
.ph-name:hover { text-decoration: underline; text-decoration-color: rgba(159, 208, 240, 0.5); }
.ph-card {
  position: absolute; top: 100%; left: 0; z-index: 200;
  margin-top: 4px; padding: 8px 11px; min-width: 220px; max-width: 320px;
  background: #0d2a42; border: 1px solid #3a6da0; border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.55);
  font-size: 12px; color: #e3f1ff; line-height: 1.45;
  white-space: nowrap; cursor: default;
}
.ph-line { margin-bottom: 2px; }
.ph-champ { color: #ffd877; }
.ph-top { opacity: 0.7; font-size: 11px; }
.ph-loading { opacity: 0.5; }
.ph-new { opacity: 0.5; font-style: italic; }
.ph-profile { display: block; margin-top: 4px; font-size: 11px; color: #9fd0f0; text-decoration: none; }
.ph-profile:hover { text-decoration: underline; }
</style>
